import { parseContentItems } from 'components/production/components/AisleContent/utils';

/**
 * Transforms a saved Banner 1 from the database into the form data structure.
 * The API stores item fields as a JSON string in `contentItems`; the form
 * expects a nested `items` array with a single entry.
 *
 * @param {Object} banner - Raw banner object from the API.
 * @returns {Object} Form-compatible data.
 */
export function transformBanner1ToFormData(banner) {
    const contentItems = parseContentItems(banner.contentItems) ?? {};
    const { bgColor, imageLeftUrl, imageRightUrl, linkUrl, openLinkInNewTab, text } = contentItems;

    return {
        id: banner.id,
        name: banner.bannerName || '',
        items: [
            {
                bgColor: bgColor ?? '#FFFFFF',
                imageLeftUrl: imageLeftUrl ?? '',
                imageRightUrl: imageRightUrl ?? '',
                linkUrl: linkUrl ?? '',
                openLinkInNewTab: openLinkInNewTab ?? true,
                text: text ?? '',
            },
        ],
    };
}

/**
 * Builds the payload for the aisle banner API from the Banner 1 form data.
 * Fields that map directly to banner columns are sent as top-level params;
 * everything else (the items array) is sent as `contentItems`.
 *
 * @param {string} aisleID - Parent aisle ID.
 * @param {Object} formData - Banner 1 form data.
 * @returns {Object} API payload.
 */
export function buildBanner1Payload(aisleID, formData) {
    const { items, name } = formData;
    const { bgColor, imageLeftUrl, imageRightUrl, linkUrl, openLinkInNewTab, text } = items[0];

    return {
        aisleID,
        bannerName: name,
        contentItems: JSON.stringify({
            bgColor,
            imageLeftUrl,
            imageRightUrl,
            linkUrl,
            name,
            openLinkInNewTab,
            text,
        }),
        displayType: 'BANNER_1',
    };
}
